// John Eldhose 20180806
import { RestfulPost } from './Restful';

export async function subscription(data) {
  data = (data === '') ? '' : { subscription: data };
  const subsc = await RestfulPost('subscription', data, (response) => {
      return response['data'];
    }, (error) => {
      console.log(error);
      return false;
    }
  );
  return subsc;
}



// WEBPACK FOOTER //
// ./src/Api/subscription.js